import { App } from '@vue/runtime-core';
import { Plugin } from 'vue';

const APP_KEY: string = '__APP__';

const appProviderPlugin: Plugin = {
    install(app: App): void {
        app.provide(APP_KEY, app);
    }
};

export { APP_KEY, appProviderPlugin };
